// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";

function s(prim) {
  return prim;
}

function ArticleLoading(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: "Lorem ipsum dolor sit amet consectetur",
                      className: "article-loading-title"
                    }),
                JsxRuntime.jsx("div", {
                      className: "article-loading-content"
                    })
              ],
              className: "loading article-loading"
            });
}

var make = ArticleLoading;

export {
  s ,
  make ,
}
/* react/jsx-runtime Not a pure module */
